import { getDeviceList, getDeviceInfo, getDeviceNetInfo, getDeviceRadioInfo, getDeviceVapInfo,
         getMacWhiteList, updateMacWhiteList, checkIsExistInMacWhiteList, siteSurvey, getPortNeighborInfo, editSwitchInfo, setupUseProfile, getDeviceInfoByMac
} from './device-data';

import {getProfileSettingRadioInfo, getProfileSettingVapInfo, getProfileSettingNetInfo} from '../../actions/settings/profile-data';

export const WAIT_INIT_DEVICE = "WAIT_INIT_DEVICE";
export const GET_DEVICE_DATA = "GET_DEVICE_DATA";
export const GET_DEVICE_DATA_SUCCESS = "GET_DEVICE_DATA_SUCCESS";
export const GET_DEVICE_DATA_FAIL = "GET_DEVICE_DATA_FAIL";
export const DISPATCH_DEVICE_AP_SCAN = "DISPATCH_DEVICE_AP_SCAN";
export const SET_DEVICE_DETAIL_DATA = "SET_DEVICE_DETAIL_DATA";
export const GET_DEVICE_DETAIL = "GET_DEVICE_DETAIL";
export const GET_DEVICE_DETAIL_SUCCESS = "GET_DEVICE_DETAIL_SUCCESS";
export const GET_DEVICE_DETAIL_FAIL = "GET_DEVICE_DETAIL_FAIL";
export const ORDER_DEVICE_LIST_SUCCESS = "ORDER_DEVICE_LIST_SUCCESS";
export const DEVICE_STATUS_UPDATED_NOTIFY = "DEVICE_STATUS_UPDATED_NOTIFY";
export const UPDATE_DEVICE_DETAIL_DATA = "UPDATE_DEVICE_DETAIL_DATA";
export const GET_DEVICE_ETHERNET = "GET_DEVICE_ETHERNET";
export const GET_DEVICE_ETHERNET_FAIL = "GET_DEVICE_ETHERNET_FAIL";
export const GET_DEVICE_ETHERNET_SUCCESS = "GET_DEVICE_ETHERNET_SUCCESS";
export const SELECT_DEVICE_ETHERNET = "SELECT_DEVICE_ETHERNET";

// reload device page
export const RELOAD_DEVICE_PAGE = "RELOAD_DEVICE_PAGE";

// device manager ap page
export const GET_DEVICE_NETWORK_INFO = "GET_DEVICE_NETWORK_INFO";
export const GET_DEVICE_NETWORK_INFO_FAIL = "GET_DEVICE_NETWORK_INFO_FAIL";
export const GET_DEVICE_NETWORK_INFO_SUCCESS = "GET_DEVICE_NETWORK_INFO_SUCCESS";
export const GET_DEVICE_RADIO_INFO = "GET_DEVICE_RADIO_INFO";
export const GET_DEVICE_RADIO_INFO_FAIL = "GET_DEVICE_RADIO_INFO_FAIL";
export const GET_DEVICE_RADIO_INFO_SUCCESS = "GET_DEVICE_RADIO_INFO_SUCCESS";
export const GET_DEVICE_VAP_INFO = "GET_DEVICE_VAP_INFO";
export const GET_DEVICE_VAP_INFO_FAIL = "GET_DEVICE_VAP_INFO_FAIL";
export const GET_DEVICE_VAP_INFO_SUCCESS = "GET_DEVICE_VAP_INFO_SUCCESS";
export const DL_DEVICE_CONFIG = "DL_DEVICE_CONFIG";
export const DL_DEVICE_CONFIG_FAIL = "DL_DEVICE_CONFIG_FAIL";
export const DL_DEVICE_CONFIG_SUCCESS = "DL_DEVICE_CONFIG_SUCCESS";
export const SELECT_PROFILE_CONFIG_INFO = "SELECT_PROFILE_CONFIG_INFO";
export const GET_PROFILE_NET_INFO = "GET_PROFILE_NET_INFO";
export const GET_PROFILE_NET_INFO_FAIL = "GET_PROFILE_NET_INFO_FAIL";
export const GET_PROFILE_NET_INFO_SUCCESS = "GET_PROFILE_NET_INFO_SUCCESS";
export const GET_PROFILE_RADIO_INFO = "GET_PROFILE_RADIO_INFO";
export const GET_PROFILE_RADIO_INFO_FAIL = "GET_PROFILE_RADIO_INFO_FAIL";
export const GET_PROFILE_RADIO_INFO_SUCCESS = "GET_PROFILE_RADIO_INFO_SUCCESS";
export const GET_PROFILE_VAP_INFO = "GET_PROFILE_VAP_INFO";
export const GET_PROFILE_VAP_INFO_FAIL = "GET_PROFILE_VAP_INFO_FAIL";
export const GET_PROFILE_VAP_INFO_SUCCESS = "GET_PROFILE_VAP_INFO_SUCCESS";
export const DELETE_DEVICE_VAP_INFO = "DELETE_DEVICE_VAP_INFO";
export const GET_DEVICE_CHECK = "GET_DEVICE_CHECK";
export const GET_SELECT_DEVICE = "GET_SELECT_DEVICE";
export const DL_DEVICE_CONTROL_CONFIRM = "DL_DEVICE_CONTROL_CONFIRM";
export const DEVICE_CHECK_FIRMWARE = "DEVICE_CHECK_FIRMWARE";
export const DEVICE_FWUPGRADE_ACK = "DEVICE_FWUPGRADE_ACK";
export const GET_DEVICE_MAC_WHITE_LIST = "GET_DEVICE_MAC_WHITE_LIST";
export const GET_DEVICE_MAC_WHITE_LIST_SUCCESS = "GET_DEVICE_MAC_WHITE_LIST_SUCCESS";
export const GET_DEVICE_MAC_WHITE_LIST_FAIL = "GET_DEVICE_MAC_WHITE_LIST_FAIL";
export const UPDATE_DEVICE_MAC_WHITE_LIST = "UPDATE_DEVICE_MAC_WHITE_LIST";
export const UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS = "UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS";
export const UPDATE_DEVICE_MAC_WHITE_LIST_FAIL = "UPDATE_DEVICE_MAC_WHITE_LIST_FAIL";
export const CHECK_IS_EXIST_MAC_WHITE_LIST = "CHECK_IS_EXIST_MAC_WHITE_LIST";
export const CHECK_IS_EXIST_MAC_WHITE_LIST_SUCCESS =  "CHECK_IS_EXIST_MAC_WHITE_LIST_SUCCESS";
export const CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL = "CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL";
export const DO_DEVICE_SITE_SURVEY = "DO_DEVICE_SITE_SURVEY";
export const DO_DEVICE_SITE_SURVEY_SUCCESS = "DO_DEVICE_SITE_SURVEY_SUCCESS";
export const DO_DEVICE_SITE_SURVEY_FAIL = "DO_DEVICE_SITE_SURVEY_FAIL";
export const GET_DEVICE_SITE_SURVEY_DATA = "GET_DEVICE_SITE_SURVEY_DATA";
export const DO_SAVE_USED_PROFILE = "DO_SAVE_USED_PROFILE";
export const DO_SAVE_USED_PROFILE_SUCCESS = "DO_SAVE_USED_PROFILE_SUCCESS";
export const DO_SAVE_USED_PROFILE_FAIL = "DO_SAVE_USED_PROFILE_FAIL";

// parameter
export const GET_DEVICE_PARAMETER_DATA = "GET_DEVICE_PARAMETER_DATA";
export const GET_MODEL_PARAMETER_DATA = "GET_MODEL_PARAMETER_DATA";

// abnormal
export const SELECT_RESOLVE_DATA = "SELECT_RESOLVE_DATA";
export const SAVE_DEVICE_ABNORMAL_DATA = "SAVE_DEVICE_ABNORMAL_DATA";

// group downlink
export const DL_DEVICE_GROUP_CONFIG = "DL_DEVICE_GROUP_CONFIG";
export const GET_PROFILE_RADIO_SETTING_INFO_SUCCESS = "GET_PROFILE_RADIO_SETTING_INFO_SUCCESS";
export const GET_PROFILE_RADIO_SETTING_INFO_FAIL = "GET_PROFILE_RADIO_SETTING_INFO_FAIL"

// profile
export const GET_SETTING_PROFILE_RADIO = "GET_SETTING_PROFILE_RADIO";
export const GET_SETTING_PROFILE_RADIO_SUCCESS = "GET_SETTING_PROFILE_RADIO_SUCCESS";
export const GET_SETTING_PROFILE_RADIO_FAIL = "GET_SETTING_PROFILE_RADIO_FAIL";
export const GET_SETTING_PROFILE_VAP = "GET_SETTING_PROFILE_VAP";
export const GET_SETTING_PROFILE_VAP_SUCCESS = "GET_SETTING_PROFILE_VAP_SUCCESS";
export const GET_SETTING_PROFILE_VAP_FAIL = "GET_SETTING_PROFILE_VAP_FAIL";
export const GET_SETTING_PROFILE_NET = "GET_SETTING_PROFILE_NET";
export const GET_SETTING_PROFILE_NET_SUCCESS = "GET_SETTING_PROFILE_NET_SUCCESS";
export const GET_SETTING_PROFILE_NET_FAIL = "GET_SETTING_PROFILE_NET_FAIL";

// switch
export const GET_SWITCH_DETAIL_INFO = "GET_SWITCH_DETAIL_INFO";
export const GET_SWITCH_DETAIL_INFO_SUCCESS = "GET_SWITCH_DETAIL_INFO_SUCCESS";
export const GET_SWITCH_DETAIL_INFO_FAIL = "GET_SWITCH_DETAIL_INFO_FAIL";
export const EDIT_SWITCH = "EDIT_SWITCH";
export const EDIT_SWITCH_SUCCESS = "EDIT_SWITCH_SUCCESS";
export const EDIT_SWITCH_FAIL = "EDIT_SWITCH_FAIL";


export const forwardDeviceList = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_DEVICE
    });
};

export const orderDeviceList = (orderList) => (dispatch) => {
    dispatch({
        type: ORDER_DEVICE_LIST_SUCCESS,
        params: {
            orderList: orderList
        }
    });
}

export const getDeviceData = (token, account, selectSite) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getDeviceList(resolve, reject, token, account, selectSite);
    });

    doPost
    .then((response) => {
        if ('success' === response.responseMsg) {
            dispatch(deviceDataSuccessAction(response.data, JSON.parse(response.deviceStatusStatistic), response.deviceConnected, response.deviceReadyToAdd));
        } else {
            dispatch({
                type: GET_DEVICE_DATA_FAIL,
                params: {
                    errMsg: response.responseMsg
                }
            });
        }            
    }).catch((err) => {
        dispatch({
            type: GET_DEVICE_DATA_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type : GET_DEVICE_DATA
    });
}

export const deviceDataSuccessAction = (pageData, statusStatistic, connectedList, readyToAddList) => (dispatch) => {
    const dispatchParm = {};
    dispatchParm.deviceList = pageData;
    if(statusStatistic) {
        dispatchParm.deviceStatistic = {
            connectd: statusStatistic.connect,
            disConnectd: statusStatistic.disconnect,
            readyToAdd: statusStatistic.readyToAdd
        }
    }
    dispatchParm.deviceConnected = connectedList;
    dispatchParm.deviceReadyToAdd = readyToAddList;

    dispatch({
        type : GET_DEVICE_DATA_SUCCESS,
        params: dispatchParm
    });
}

export const deviceAPScanAction = (scanStart, scanResult) => (dispatch) => {
    dispatch({
        type : DISPATCH_DEVICE_AP_SCAN,
        params: {
            scanStart: scanStart,
            scanResult: scanResult
        }
    });
}

export const deviceDataFailAction = (err) => (dispatch) => {
    dispatch({
        type : GET_DEVICE_DATA_FAIL,
        params: {
            deviceList: err
        }
    });
}

export const doGetDeviceInfoByMac = (mac, token) => (dispatch) => {
    if (mac) {
        let doPost = new Promise((resolve, reject) => {
            getDeviceInfoByMac(resolve, reject, token, mac);
        });
        doPost
        .then((res) => {
            if ('success' === res.responseMsg) {
                dispatch({
                    type: GET_DEVICE_DETAIL_SUCCESS,
                    params: {
                        deviceDetail: res.info
                    }
                });
            } else {
                dispatch({
                    type: GET_DEVICE_DETAIL_FAIL,
                    params: {
                        errMsg: res.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_DEVICE_DETAIL_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: GET_DEVICE_DETAIL
    });
}

export const loadDeviceDetail = (data, token/*, groupSeq*/) => (dispatch) => {
    doGetDeviceInfo(dispatch, token, data);
    doGetDeviceRadioInfo(dispatch, token, data);
    doGetProfileSettingRadioInfo(dispatch, token, data);
}

export const loadDeviceConfig = (data, token) => (dispatch) => {
    doGetDeviceNetInfo(dispatch, token, data);
    doGetProfileSettingNetInfo(dispatch, token, data);
    doGetDeviceRadioInfo(dispatch, token, data);
    doGetProfileSettingRadioInfo(dispatch, token, data);
    doGetDeviceVapInfo(dispatch, token, data);
    doGetProfileSettingVapInfo(dispatch, token, data);
}

export const loadProfileInfoAction = (token/*, profileName*/) => (dispatch) => {
    doGetProfileSettingVapInfo(dispatch, token);
}

export const loadSwitchDetail = (data, token) => (dispatch) => {
    doGetDeviceInfo(dispatch, token, data)
}

export const dispatchDeviceUpdatedNotify = (updateTimestamp) => (dispatch) => {
    dispatch({
        type : DEVICE_STATUS_UPDATED_NOTIFY,
        params: {
            deviceStatusUpdatTimestamp: updateTimestamp,
        }
    });
}

export const deviceParameterDataAction = (monitorColumnsConfig) => (dispatch) => {
    dispatch({
        type : GET_DEVICE_PARAMETER_DATA,
        params: {
            monitorColumnsConfig: monitorColumnsConfig,
            // abnormalColumnsConfig: abnormalColumnsConfig,
            // managerColumnsConfig: managerColumnsConfig
        }
    });
}

export const selectDeviceEthernet = (ethernetSeq) => (dispatch) => {
    dispatch({
        type: SELECT_DEVICE_ETHERNET,
        params: {
            selectEthernet: ethernetSeq
        }
    });
}

export const selectAbnormalResolve = (resolve) => (dispatch) => {
    dispatch({
        type: SELECT_RESOLVE_DATA,
        params: {
            resolveData: resolve
        }
    });
}

export const saveDeviceAbnormal = (info, confirm) => (dispatch) => {
    dispatch({
        type: SAVE_DEVICE_ABNORMAL_DATA,
        params: {
            info: info,
            confirm: confirm
        }
    });
}



export const dispatchDlDeviceControl = (info, confirm) => (dispatch) => {
    dispatch({
        type: DL_DEVICE_CONTROL_CONFIRM,
        params: {
            info: info,
            confirm: confirm
        }
    });
}

export const dispatchSelectProfile = (profileName) => (dispatch) => {
    dispatch({
        type: SELECT_PROFILE_CONFIG_INFO,
        params: {
            profileName: profileName
        }
    });
}

const doGetDeviceInfo = (dispatch, token, data) => {
    if (data) {
        let doPost = new Promise((resolve, reject) => {
            getDeviceInfo(resolve, reject, token, data);
        });
    
        doPost
        .then((res) => {
            if ('success' === res.responseMsg) {
                dispatch({
                    type: GET_DEVICE_DETAIL_SUCCESS,
                    params: {
                        deviceDetail: res.info
                    }
                });
                if (data.model === 'MS12') {
                    doGetSwitchPortNeighbor(dispatch, token, data)
                }
                
            } else {
                dispatch({
                    type: GET_DEVICE_DETAIL_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_DEVICE_DETAIL_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    }

    dispatch({
        type: GET_DEVICE_DETAIL
    });
}

const doGetDeviceNetInfo = (dispatch, token, device) => {
    if (device) {
        let doPost = new Promise((resolve, reject) => {
            getDeviceNetInfo(resolve, reject, token, device);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_DEVICE_NETWORK_INFO_SUCCESS,
                    params: {
                        deviceNetworkInfo: data
                    }
                });
            }
            
        }).catch((err) => {
            dispatch({
                type: GET_DEVICE_NETWORK_INFO_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: GET_DEVICE_NETWORK_INFO
    });
}

const doGetDeviceRadioInfo = (dispatch, token, device) => {
    if (device) {
        let doPost = new Promise((resolve, reject) => {
            getDeviceRadioInfo(resolve, reject, token, device);
        });
    
        doPost
        .then((res) => {
            if ('success' === res.responseMsg) {
                dispatch({
                    type: GET_DEVICE_RADIO_INFO_SUCCESS,
                    params: {
                        deviceRadioInfo: res.radioInfo
                    }
                });
            }
            
        }).catch((err) => {
            dispatch({
                type: GET_DEVICE_RADIO_INFO_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: GET_DEVICE_RADIO_INFO
    });
}

const doGetDeviceVapInfo = (dispatch, token, device) => {
    if (device) {
        let doPost = new Promise((resolve, reject) => {
            getDeviceVapInfo(resolve, reject, token, device);
        });
    
        doPost
        .then((res) => {
            if ('success' === res.responseMsg) {
                dispatch({
                    type: GET_DEVICE_VAP_INFO_SUCCESS,
                    params: {
                        deviceVapInfo: res.vapInfo
                    }
                });
            }
            
        }).catch((err) => {
            dispatch({
                type: GET_DEVICE_VAP_INFO_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: GET_DEVICE_VAP_INFO
    });
}

export const doSetupUseProfile = (usedProfileFlag, mac, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        setupUseProfile(resolve, reject, usedProfileFlag, mac, token);
    });

    doPost
        .then((res) => {
            if ('success' === res.responseMsg) {
                dispatch({
                    type: DO_SAVE_USED_PROFILE_SUCCESS,
                    
                });
            }

        }).catch((err) => {
            dispatch({
                type: DO_SAVE_USED_PROFILE_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: DO_SAVE_USED_PROFILE
    });
}


export const dispatchCheckDeviceList = (checkDevice, chooseDevice) => (dispatch) => {
    dispatch({
        type : GET_DEVICE_CHECK,
        params: {
            checkDevice: checkDevice,
            chooseDevice: chooseDevice
        }
    });
}

export const dispatchReloadDevicePage = (reloadTime) => (dispatch) => {
    dispatch({
        type : RELOAD_DEVICE_PAGE,
        params: {
            reloadTime: reloadTime
        }
    });
}

export const dispatchSelectDeviceList = (selectedDevice) => (dispatch) => {
    dispatch({
        type : GET_SELECT_DEVICE,
        params: {
            selectedDevice: selectedDevice
        }
    });
}

export const dispatchDeleteDeviceVapList = (deleteVapInfo) => (dispatch) => {
    dispatch({
        type : DELETE_DEVICE_VAP_INFO,
        params: {
            deleteVapInfo: deleteVapInfo
        }
    });
}

export const dispatchDeviceCheckFirmware = (checkFirmwareStart, reloadAPPage) => (dispatch) => {
    dispatch({
        type : DEVICE_CHECK_FIRMWARE,
        params: {
            checkFirmwareStart: checkFirmwareStart,
            reloadAPPage: reloadAPPage
        }
    });
}

export const dispatchDeviceFwUpgradeACK = (firmUpdAckTimestamp) => (dispatch) => {
    dispatch({
        type : DEVICE_FWUPGRADE_ACK,
        params: {
            firmUpdAckTimestamp: firmUpdAckTimestamp
        }
    });
}

export const doGetMacWhiteList = (token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getMacWhiteList(resolve, reject, token);
    });

    doPost
    .then((response) => {
        if ('success' === response.responseMsg) {
            dispatch({
                type: GET_DEVICE_MAC_WHITE_LIST_SUCCESS,
                params: {
                    macWhiteList: response.data
                }
            });
        } else {
            dispatch({
                type: GET_DEVICE_MAC_WHITE_LIST_FAIL,
                params: {
                    errMsg: response.responseMsg
                }
            });
        }            
    }).catch((err) => {
        dispatch({
            type: GET_DEVICE_MAC_WHITE_LIST_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type : GET_DEVICE_MAC_WHITE_LIST
    });
}

export const doUpdateMacWhiteList = (token, ids) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        updateMacWhiteList(resolve, reject, token, ids);
    });

    doPost
    .then((response) => {
        if ('success' === response.responseMsg) {
            dispatch({
                type: UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS,
                params: {
                    macWhiteList: response.data
                }
            });
        } else {
            dispatch({
                type: UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
                params: {
                    errMsg: response.responseMsg
                }
            });
        }            
    }).catch((err) => {
        dispatch({
            type: UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type : UPDATE_DEVICE_MAC_WHITE_LIST
    });
}

export const doCheckIsExistInMacWhiteList = (mac) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        checkIsExistInMacWhiteList(resolve, reject, mac);
    });

    doPost
    .then((data) => {     
        if (data.responseMsg === 'success') {
            dispatch({
                type: CHECK_IS_EXIST_MAC_WHITE_LIST_SUCCESS,
                params: {
                    isExistInMacWhiteList: data.data
                }
            });
        } else {
            dispatch({
                type: CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL,
            });
        }        
    }).catch((err) => {
        dispatch({
            type: CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: CHECK_IS_EXIST_MAC_WHITE_LIST       
    });
}

export const doSiteSurvey = (token, objBody, deviceRadioInfo) => (dispatch) => {
    let radioLst = [], intcont = 0;

    deviceRadioInfo.forEach(e => {
        if(e.status === "enable"){
            radioLst.push(e.radio);
            intcont++;
        }
    })

    let doPost = new Promise((resolve, reject) => {
        siteSurvey(resolve, reject, token, objBody, radioLst.join(":"), intcont.toString());
    });

    doPost
    .then((data) => {     
        if (data.responseMsg === 'success') {
            dispatch({
                type: DO_DEVICE_SITE_SURVEY_SUCCESS,
            });
        } else {
            dispatch({
                type: DO_DEVICE_SITE_SURVEY_FAIL,
            });
        }        
    }).catch((err) => {
        dispatch({
            type: DO_DEVICE_SITE_SURVEY_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DO_DEVICE_SITE_SURVEY       
    });
}

export const dispatchSiteSurveyData = (wifi, wifi1, wifiAll, wifi1All, rogueAll) => (dispatch) => {
    dispatch({
        type: GET_DEVICE_SITE_SURVEY_DATA,
        params: {
            wifiList: wifi,
            wifiList1: wifi1,
            wifiWithRogue: wifiAll,
            wifi1WithRogue: wifi1All,
            rogueAll: rogueAll
        }
    });
}

export const doGetProfileSettingRadioInfo = (dispatch, token, device) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileSettingRadioInfo(resolve, reject, token, device);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_RADIO_SUCCESS,
                params: {
                    profileRadioList: data.profileSettingRadioInfo
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_RADIO_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_RADIO_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_RADIO
    });
}

export const doGetProfileSettingVapInfo = (dispatch, token, device) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileSettingVapInfo(resolve, reject, token, device);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_VAP_SUCCESS,
                params: {
                    profileVapList: data.profileSettingVapInfo
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_VAP_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_VAP_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_VAP
    });
}

export const doGetProfileSettingNetInfo = (dispatch, token, device) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileSettingNetInfo(resolve, reject, token, device);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_NET_SUCCESS,
                params: {
                    profileNetList: data.profileSettingNetInfo
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_NET_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_NET_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_NET
    });
}

export const doGetSwitchPortNeighbor = (dispatch, token, mswitch) => {
    let doPost = new Promise((resolve, reject) => {
        getPortNeighborInfo(resolve, reject, token, mswitch);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SWITCH_DETAIL_INFO_SUCCESS,
                params: {
                    switchDetailPort: data.ports,
                    switchDetailNeighbor: data.neighbors
                }
            });
        } else {
            dispatch({
                type: GET_SWITCH_DETAIL_INFO_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SWITCH_DETAIL_INFO_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SWITCH_DETAIL_INFO
    });
}

export const doEditSwitchInfo = (token, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            editSwitchInfo(resolve, reject, token, reqBodyObj)
        })

        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: EDIT_SWITCH_SUCCESS,
                });
            } else {
                dispatch({
                    type: EDIT_SWITCH_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: EDIT_SWITCH_FAIL,
                params: {
                    errMsg: err
                }
            });
        }); 
    }

    dispatch({
        type: EDIT_SWITCH
    });
}